// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vc-container .vc-time-picker .vc-date-time{margin-left:0!important}.vc-container .vc-time-picker .vc-date-time .vc-date{display:none!important}.vc-container .vc-time-picker .vc-am-pm button{font-size:.7rem!important}.vc-container .vc-select select{font-family:system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif!important;font-size:.8rem!important}.vc-container .vc-time-icon{display:none!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
